import { AxiosError } from 'axios';

export type ReservationErrorCode = 'RESERVATION_BLOCKED_CIRCUIT_DELETED';

export const parseReservationErrorCode = (
  error: unknown,
): ReservationErrorCode | null => {
  if (error instanceof AxiosError) {
    const data = error.response?.data as { code?: string } | undefined;
    if (data?.code === 'RESERVATION_BLOCKED_CIRCUIT_DELETED') {
      return data.code;
    }
  }
  return null;
};
